import React from 'react';
import PropTypes from 'prop-types';
import './rectangle-shimmer.scss';

const RectangleShimmer = ({ className, width, height }) => (
  <div
    style={{ width, height }}
    className={className}
  />
);

RectangleShimmer.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

RectangleShimmer.defaultProps = {
  width: '200px',
  height: '50px',
  className: '',
};

export default RectangleShimmer;
